<div class="tabbar">
	<i [routerLink]="['/portal/stage', scene.id]" class="tabbar__back fa fa-angle-left"></i>
	<div class="tabbar__navigation tabs">
		<div *ngFor="let tab of tabs" class="tabs__tab" [routerLink]="['tab', tab.id]" [routerLinkActive]="'tabs__tab--active'">{{ tab.title[language] }}</div>
		<div class="tabs__tab" [routerLink]="['form']" [routerLinkActive]="'tabs__tab--active'">{{ 'FORM.TAB' | translate }}</div>
	</div>
</div>
<router-outlet></router-outlet>



// WEBPACK FOOTER //
// /var/data/workspace/hess/hess_smart_city_web/src/app/components/content/content.component.html